// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"85e7f1f3","453":"e16f9c3e","455":"cc767cfc","977":"e8098fbd"}[chunkId] + ".chunk.js";
};